<template>
  <el-main class="materialwrap">
    <div class="mybread">
      <p><i class="el-icon-location"></i>当前位置：</p>
      <el-breadcrumb separator-class="el-icon-arrow-right" v-if="query.kind == 1">
        <el-breadcrumb-item>客户项目</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/project' }">项目列表</el-breadcrumb-item>
        <el-breadcrumb-item :to="{
          path: `/project/detail?id=${query.cid ? query.cid : query.pid}`,
        }">项目详情</el-breadcrumb-item>
        <el-breadcrumb-item>项目收入详情</el-breadcrumb-item>
      </el-breadcrumb>
      <el-breadcrumb separator-class="el-icon-arrow-right" v-else>
        <el-breadcrumb-item>客户项目</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/apply' }">收款管理</el-breadcrumb-item>
        <el-breadcrumb-item>项目收入详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="base1">
      <h3 class="ntitle">发票申请记录</h3>
      <ul v-for="(item, index) in form.applyLogList" :key="`log_${index}`">
        <li>
          <p>
            <label>项目名称：</label><a>{{
              projectArr.contract_name
                ? projectArr.contract_name
                : form.projectArr.contract_name
            }}</a>
          </p>
          <p>
            <label>发票类型：</label><a>{{ dd.invoice_type[item.description.type] }}</a>
          </p>
          <p>
            <label>税率：</label><a>{{ item.description.tax_rate + "%" }}</a>
          </p>
          <p>
            <label>期望开票时间：</label><a>{{ item.description.hope_time }}</a>
          </p>
          <p>
            <label>发票备注：</label><a>{{ item.description.invoice_mark }}</a>
          </p>
          <p>
            <label>备注：</label><a>{{ item.description.info }}</a>
          </p>
          <p>
            <label>{{
              index == form.applyLogList.length - 1
                ? "发票申请时间："
                : "重新申请发票时间："
            }}</label><a>{{ item.created_at }}</a>
          </p>
        </li>
        <li>
          <p>
            <label>收款计划名称：</label><a>{{ form.billArr && form.billArr.bill_name }}</a>
          </p>
          <p>
            <label>开票金额：</label><a>{{ item.description.amount }}</a>
          </p>
          <p>
            <label>税额：</label><a>{{ item.description.tax }}</a>
          </p>
          <p>
            <label>开票内容：</label><a>{{ dd.category_type[item.description.category] }}</a>
          </p>
        </li>
      </ul>
    </div>
    <div class="base1">
      <h3 class="ntitle">开票信息</h3>
      <ul>
        <li>
          <p>
            <label>客户公司名称：</label><a>{{ form.client_company }}</a>
          </p>
          <p>
            <label>公司注册地址：</label><a>{{ form.reg_address }}</a>
          </p>
          <p>
            <label>银行名称：</label><a>{{ form.pay_bank }}</a>
          </p>
        </li>
        <li>
          <p>
            <label>统一社会信用代码：</label><a>{{ form.company_id_card }}</a>
          </p>
          <p>
            <label>公司电话：</label><a>{{ form.company_phone }}</a>
          </p>
          <p>
            <label>银行账号：</label><a class="hoverlink" @click="clickCopy(form.pay_bank_account)">{{
              form.pay_bank_account
            }}</a>
          </p>
        </li>
      </ul>
    </div>
    <div class="base1">
      <h3 class="ntitle">发票信息</h3>
      <div class="operater">
        <div class="linkbox" :class="{ grey: form.cancel_status == '1' }" @click="
          form.cancel_status == '0'
            ? (cancelShow = true)
            : (cancelShow = false)
          " v-if="NodeInclude('55')">
          发票申请作废
        </div>
      </div>
      <ul v-for="(item, index) in form.invoiceList" :key="index">
        <li>
          <p>
            <label>发票代码：</label><a>{{ item.invoice_code }}</a>
          </p>
          <p>
            <label>金额：</label><a>{{ item.invoice_amount }}</a>
          </p>
          <p>
            <label>发票状态：</label><a>{{ dd.invoice_update[item.status] }}</a>
          </p>
          <p>
            <label>发票附件：</label>
            <template>
              <ul class="bbox">
                <li v-for="(_it, _id) in item.atta_str" :key="_id">
                  <el-col :span="24" v-if="_it.origin_name">
                    <el-col :span="20">
                      <div class="origin-name">{{ _it.origin_name }}</div>
                    </el-col>
                    <el-col :span="4">
                      <el-link type="primary" style="margin-right: 5px" :href="_it.httpFile"
                        target="_blank">查看</el-link>
                    </el-col>
                  </el-col>
                  <el-col :span="24" v-else> 暂无发票 </el-col>
                </li>
              </ul>
            </template>
          </p>
        </li>
        <li>
          <p>
            <label>发票号码：</label><a>{{ item.invoice_no }}</a>
          </p>
          <p>
            <label>发票日期：</label><a>{{ item.invoice_date }}</a>
          </p>
        </li>
      </ul>
    </div>
    <div class="base1">
      <h3 class="ntitle">收款信息</h3>
      <ul v-for="(item, index) in form.receiveList" :key="index">
        <li>
          <p>
            <label>收款金额：</label><a>{{ item.receive_amount }}</a>
          </p>
          <p>
            <label>收款日期：</label><a>{{ item.receive_date }}</a>
          </p>
          <p>
            <label>收款凭证附件：</label>
            <template>
              <ul class="bbox">
                <li v-for="(_it, _id) in item.atta_str" :key="_id">
                  <el-col :span="24" v-if="_it.origin_name">
                    <el-col :span="20">
                      <div class="origin-name">{{ _it.origin_name }}</div>
                    </el-col>
                    <el-col :span="4">
                      <el-link type="primary" style="margin-right: 5px" :href="_it.httpFile"
                        target="_blank">查看</el-link>
                    </el-col>
                  </el-col>
                  <el-col :span="24" v-else> 暂无收款凭证 </el-col>
                </li>
              </ul>
            </template>
          </p>
        </li>
        <li></li>
      </ul>
      <ul>
        <li style="padding-left: 0">
          <p>
            <label>收款状态：</label><a>{{
              form.status ? dd.is_receive_apply[form.is_receive] : "未收款"
            }}</a>
          </p>
        </li>
      </ul>
    </div>

    <el-dialog title="发票申请作废确认" :visible.sync="cancelShow" width="400px">
      <ul class="aul" style="padding: 0 20px">
        <li style="margin-bottom: 15px">
          <span>发票作废不可逆。您是否确认申请把该收款计划下的全部发票作废？</span>
        </li>
        <li>
          <el-input placeholder="请输入备注" v-model="cancel_info" clearable></el-input>
        </li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelShow = false">取 消</el-button>
        <el-button type="primary" @click="cancelClick">确 定</el-button>
      </span>
    </el-dialog>
  </el-main>
</template>

<script>
import * as api from '@/api'
import { timeFormat } from "@/utils/index.js";
export default {
  name: "applydetail",
  data() {
    return {
      nodeLimtList: [],
      billList: [],
      projectArr: {},
      billArr: {
        bill_name: "",
        amount: "",
      },
      projectList: [],
      form: {
        //客户信息
        apply_id: "",
        project_id: "",
        project_bill_id: "",
        type: "2",
        amount: "",
        tax_rate: "",
        tax: "",
        hope_time: "",
        category: "1",
        invoice_mark: "",
        info: "",
        client_company: "",
        company_id_card: "",
        reg_address: "",
        company_phone: "",
        pay_bank: "",
        pay_bank_account: "",
        receive_date: "",
        projectArr: {
          contract_name: "",
        },
      },
      del_receive_list: [],
      del_atta_list: [],
      p: 1,
      type: 0,
      cancelShow: false,
      cancel_info: "",
    };
  },
  created() {
    this.query = this.$route.query;
    this.query.id && this.getDetail(this.query.id);
    this.query.pid &&
      (this.form.project_id = this.query.pid) &&
      this.projectChange(this.query.pid);
  },
  mounted() { },
  watch: {
    ["form.pay_bank_account"](val) {
      if (val != undefined) {
        this.$nextTick(() => {
          this.form.pay_bank_account = val
            .replace(/\D/g, "")
            .replace(/....(?!$)/g, "$& ");
        });
      }
    },
  },
  methods: {
    checkUrlFn() {
      // 获取当前URL的哈希部分  
      const hash = window.location.hash;  
      // 移除'#'字符  
      const url = hash.substring(1); 
      
      let postData = {
        url_path: url
      }
      api.checkLoginUrl(postData).then((res) => {
        if (res.status == 400) {
          this.$message({
            type: 'info',
            message: '暂无权限',
          })
          this.$router.push({
            path: `/home`
          });
        }
      })
    },
    checkNodeFn(menu_id) {
      let postData = {
        menu_id,
      }
      api.checkNode(postData).then((res) => {
        this.nodeLimtList = res.node_ids.split(',')
      })
    },
    NodeInclude(val) {
      return this.nodeLimtList.includes(val)
    },
    //选择文件
    async getDetail(id) {
      this.checkUrlFn()
      this.checkNodeFn(`61`)
      this.$fly
        .post("apiSale_getInvoiceApplyDetail.html", {
          apply_id: id,
        })
        .then((res) => {
          let form = res.itemArr;
          const atta_str = () => [
            { origin_name: "", file_name: "", httpFile: "", id: "", flist: [] },
          ];
          //修改0000-00-00错误显示1899年情况
          form.receiveList = form.receiveList.map((item) => {
            item.receive_date = timeFormat(item.receive_date);
            item.atta_str =
              item.fileList.length != 0 ? item.fileList : atta_str();
            return item;
          });
          form.invoiceList = form.invoiceList.map((item) => {
            item.invoice_date = timeFormat(item.invoice_date);
            item.atta_str =
              item.fileList.length != 0 ? item.fileList : atta_str();
            return item;
          });
          return (this.form = form);
        });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addUpdateInvoiceApply();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    addUpdateInvoiceApply() {
      this.form.apply_id = this.query.id || "";
      this.form.option = this.form.id ? "2" : "1";
      // 替换掉id为receive_id
      const $receiveList = this.form.receiveList.map((item) => {
        Object.keys(item).forEach((key) => {
          if (key == "id") {
            item["receive_id"] = item[key];
            delete item[key];
          }
        });
        // 替换掉id为file_id
        item.atta_str = item.atta_str.map((it) => {
          delete it.flist;
          delete it.httpFile;
          delete it.create_time;
          Object.keys(it).forEach((_key) => {
            if (_key == "id") {
              it["file_id"] = it[_key] || 0;
              delete it[_key];
            }
          });
          return it;
        });
        delete item.create_time;
        delete item.cancel_time;
        return item;
      });
      this.form.receiveList = $receiveList;
      const tempForm = JSON.parse(JSON.stringify(this.form))
      delete tempForm.projectArr
      delete tempForm.billArr
      delete tempForm.receiveList
      delete tempForm.invoiceList
      delete tempForm.applyLogList
      this.$fly
        .post("apiSale_addUpdateInvoiceApply.html", {
          ...this.form,
          receive_str: JSON.stringify(tempForm.receiveList),
          receive_del: this.del_receive_list.toString(),
          receive_atta_del: this.del_atta_list.toString(),
        })
        .then((res) => {
          console.log(res);
          if (res.status === 200) {
            this.$message.success(res.message);
          }
          this.$router.go(-1);
        });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$router.go(-1);
    },
    clickCopy(msg) {
      const save = function (e) {
        e.clipboardData.setData("text/plain", msg.replace(/\s*/g, ""));
        e.preventDefault(); // 阻止默认行为
      };
      const once = {
        once: true,
      };
      document.addEventListener("copy", save, once); // 添加一个copy事件,当触发时执行一次,执行完删除
      document.execCommand("copy"); // 执行copy方法
      this.$message({ message: "复制成功", type: "success" });
    },
    cancelClick() {
      let invoice_ids_arr = [];
      let invoice_ids = "";
      for (let i = 0; i < this.form.invoiceList.length; i++) {
        const invoiceItem = this.form.invoiceList[i].id;
        invoice_ids_arr.push(invoiceItem);
      }
      invoice_ids = invoice_ids_arr.join(",");
      this.$fly
        .post("apiSale_applyInvoiceCancel.html", {
          invoice_ids: invoice_ids,
          cancel_info: this.cancel_info,
        })
        .then((res) => {
          if (res.status == "200") {
            this.$message.success("成功申请作废");
            this.cancelShow = false;
            this.query.id && this.getDetail(this.query.id);
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.materialwrap {
  .form.myform {
    padding-left: 100px;
  }

  .form {
    @extend %box;
    padding: 30px;
    margin-bottom: 20px;

    .anlist {
      padding: 0;

      li {
        position: relative;

        .abox {
          .abox-title {
            font-size: 13px;
            line-height: 32px;
            margin-bottom: 30px;
          }
        }

        .abtn {
          position: absolute;
          top: 0;
          left: 65%;
        }

        .bbtn {
          position: absolute;
          top: 0;
          left: 60%;
        }
      }
    }
  }

  .formtitle {
    position: relative;
    left: -50px;
    margin-bottom: 30px;
    font-size: 28px;
    line-height: 48px;
    font-weight: 600;
  }

  .base1 {
    @extend %box;
    margin-bottom: 20px;
    padding: 30px 40px;
    position: relative;

    ul {
      @extend %start;
      color: var(--text-1); /* 0819修改 */;
      background: var(--bg-soft); /* 0819修改 */
      padding: 0 25px;
      border-radius: 20px;
      margin-bottom: 20px;
      position: relative;

      &:last-of-type {
        margin-bottom: 0;
      }

      li {
        width: 50%;
        font: 14px/3 $font;

        p {
          min-height: 42px;
          padding: 5px 0;
          @extend %start;

          label {
            width: 150px;
            white-space: nowrap;
            flex: none;
          }

          .bbox {
            width: 100%;
            padding: 0;
            display: block;

            li {
              width: 100%;
              height: 42px;

              &:last-child {
                width: 100%;
                padding-left: 0;
              }
            }
          }
        }
      }
    }
  }
}

.operater {
  @extend %start;
  position: absolute;
  top: 30px;
  right: 40px;
  font: 14px/1 $font;
  text-align: center;

  >div {
    min-width: 32px;
    border: 1px solid #dcdfe6;
    border-radius: 3px;
    padding: 9px 10px;
    cursor: pointer;

    &.linkline {
      border-color: transparent;
      background: transparent;
      color: var(--text-1); /* 0819修改 */;

      &:hover {
        &::after {
          display: block;
          content: "";
          height: 0.1px;
          background: #231f20;
        }
      }
    }

    &.linkbox {
      border-color: #0e0f22;
      background: #0e0f22;
      color: #fff;

      &.grey {
        border-color: #c0c4cc;
        background: #c0c4cc;
        color: #fff !important;

        &:hover {
          background: #c0c4cc;
        }
      }

      &:hover {
        background: rgba($color: #0e0f22, $alpha: 0.8);
      }
    }
  }
}
</style>
